import HttpClient from '../../../services/http-client';
import { IBudgetActionFilterRequest } from '../../../../model/sge/budget-action/request/budget-action-filter-request';
import { IBudgetActionAddEditRequest } from '../../../../model/sge/budget-action/request/budget-action-add-edit-request';
import { IBudgetActionResponse } from '../../../../model/sge/budget-action/response/budget-action-response';

const defaultPath = 'BudgetAction';

const list = async (params?: IBudgetActionFilterRequest): Promise<IBudgetActionResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params
    }).then((response) => response.data);
};

const getById = async (id: number): Promise<IBudgetActionResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: IBudgetActionAddEditRequest): Promise<IBudgetActionResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: { budgetProgramId: params.budgetProgramId, actionType: params.actionType, code: params.code, name: params.name }
    }).then((response) => response.data);
};

const edit = async (id: number, params: IBudgetActionAddEditRequest): Promise<IBudgetActionResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: { actionType: params.actionType, code: params.code, name: params.name }
    }).then((response) => response.data);
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

const BudgetActionAppService = { list, getById, add, edit, remove };
export default BudgetActionAppService;
